import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const ROLES_STORAGE_KEY = 'roles';

interface RolesState {
  roles: string[];
}

const initialState: RolesState = {
  roles: [],
};

export const rolesSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    getRolesFromLocalStore: state => {
      const data = localStorage.getItem(ROLES_STORAGE_KEY) || '';
      if (data) {
        state.roles = [data];
      }
    },
    setRoles: (state, action: PayloadAction<string[]>) => {
      state.roles = action.payload;
      localStorage.setItem(ROLES_STORAGE_KEY, state.roles.join(','));
    },
  },
});

export const { setRoles, getRolesFromLocalStore } = rolesSlice.actions;

export const selectRoles = (state: any) => state.roles.roles;

export default rolesSlice.reducer;
